<template>
<div class="form-row">
    <div class="col-5">
        <form-input :label="employeeContributionLabel" placeholder="e.g. 3%" v-model="formData.employee_contribution" :errors="errors.employee_contribution" type="decimal" />
    </div>

    <div class="col-5">
        <form-input label="Employer will match (%)" placeholder="e.g. 100%" v-model="formData.employer_match" :errors="errors.employer_match" type="decimal" />
    </div>

    <div class="col-1">
        <a v-if="showRemove" href class="btn btn-outline-primary" @click.prevent="$emit('remove')">X</a>
    </div>
</div>
</template>

<script>
import FormMixin from '@/mixins/Form'

export default {
    // A single tier row within EmployerMatchForm: one band's width and its match rate.
    props: ['employeeContributionLabel', 'showRemove', 'modelValue'],
    mixins: [FormMixin, ],
    emits: ['remove', 'update:modelValue'],
    watch: {
        formData: {
            handler() {
                this.$emit('update:modelValue', {
                    employee_contribution: this.formData.employee_contribution,
                    employer_match: this.formData.employer_match,
                })
            },
            deep: true,
        },
    },
    data() {
        return {
            errors: {},
            formData: this.makeFormData(),
            formRules: {
                employee_contribution: {presence: {allowEmpty: false}, numericality: {greaterThanOrEqualTo: 0, lessThanOrEqualTo: 100}},
                employer_match: {presence: {allowEmpty: false}, numericality: {greaterThanOrEqualTo: 0, lessThanOrEqualTo: 100}},
            },
        }
    },
    methods: {
        makeFormData() {
            return {
                employee_contribution: this.modelValue.employee_contribution ? this.modelValue.employee_contribution : '',
                employer_match: this.modelValue.employer_match ? this.modelValue.employer_match : '',
            }
        },
    },
}
</script>
